export default __webpack_public_path__ + "static/0198-08aa64d3c564acad6962ceab62c1ed1b.png";